
/**
 * @todo Move the $.debounce initialisation functionality into here.
 */
export default class Helpers {
    /**
     * Grabs JQuery without normal import statement. Useful for this same class because otherwise I'd be boring myself writing import $ from "jquery" lol.
     * 
     * @returns {JQuery}
     */
    static async jqueryAsync() {
        return ( await import( "jquery" ) ).default;
    }

    /**
     * Are we on a given page?
     * 
     * @param {String} pageSlug 
     * @returns {Boolean}
     */
    static isPage( pageSlug ) {
        return !! window.document?.body?.classList?.contains( `page--${ pageSlug}` );
    }

    /**
     * Gets a backend configurable parameter.
     * 
     * @param {String|null} key 
     * @returns 
     */
    static vlConfig( key = null ) {
        if ( ! key ) {
            return window[ 'vlConfig' ];
        }

        return ( window[ 'vlConfig' ] ?? {} )[ key ];
    }

    /**
     * Are we debugging with WP_DEBUG?
     * 
     * @returns {Boolean}
     */
    static isDebug() {
        return ( window[ 'WP_DEBUG' ] === true ) ?? false;
    }

    /**
     * Searches on YouTube.
     * 
     * @param {String} key 
     * @param {Object} parameters 
     */
    static async searchYouTube( key, parameters ) {
        var url = `https://www.googleapis.com/youtube/v3/search?key=${key}`;

        for ( key in parameters ) {
            url += `&${ key }=${ parameters[ key ] }`;
        }

        const response = await ( await Helpers.jqueryAsync() ).ajax( {
            url: url,
            method: "GET"
        } );
        
        return response;
    }

    /**
     * Creates a numeric hash of a given string.
     * 
     * https://www.geeksforgeeks.org/how-to-create-hash-from-string-in-javascript/
     * 
     * @param {String} string 
     * @returns {Number} Hash of `string`.
     */
    static hash( string ) {
        // Output hash.
        let hash = 0;
         
        // If the string has no length then it has no hash.
        if ( string.length === 0 )  {
            return hash;
        }
         
        // Iterate on all of the letters and modify the `hash` variable according to the ordinal value of the letter.
        for ( let i = 0; i < string.length; i++ ) {
            let char = string.charCodeAt( i );
            hash = ( ( hash << 5 ) - hash ) + char;
            hash = hash & hash;
        }
         
        return hash;
    }
}